// Components==============
import Button from 'components/UI/Button/Button';
import TooltipMenu from 'components/UI/Tooltip/TooltipMenu';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './ChangeFormatSettings.module.scss';
import LayoutButtons from './LayoutButtons/LayoutButtons';
// =========================

export default function ChangeFormatSettings() {
  const translate = useTranslate();
  return (
    <>
      <TooltipMenu
        content={
          <div styleName="tooltip-menu">
            <p>{translate('portfolio.actions.choose-layout')}</p>
            <LayoutButtons />
          </div>
        }
        position="bottom-right"
      >
        <Button color="grey">
          {translate('portfolio.actions.change-grid')}
        </Button>
      </TooltipMenu>
    </>
  );
}
